import React from 'react';
import { useRouteError } from 'react-router-dom';
import { ErrorBlock } from 'antd-mobile';
function ErrorElement() {
  const error = useRouteError();
  React.useEffect(() => {
    if (window.$BooheeSender) {
      window.$BooheeSender?.reportError(error);
    }
  }, [error]);

  return (
    <div
      style={{
        height: '100vh',
        padding: '10vh'
      }}>
      <ErrorBlock
        status="default"
        style={{
          '--image-height': '20vh'
        }}
        description={<span>请稍后重试</span>}
      />
    </div>
  );
}
export default ErrorElement;
